module.exports = __webpack_public_path__ + "img/5-5.0e92aac5.png";